import React, { Fragment, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { H3, P } from "@modul-connect/shared/components/atoms/text";
import View from '@modul-connect/shared/components/atoms/view';
import { useLoadingTimer } from '@modul-connect/shared/hooks';
import './widget.css';
import { timespanOptions, TimespanPicker } from '../../../../portal/src/pages/reports/datePickers/timespanPickers/timespanPickers';
import { borderStyle } from '../../organisms/paperWithHeader/paperWithHeader';
import { DateTime } from 'luxon';
import { RadioButtonSelector } from '../../molecules/radioButtonSelector';
import { dateTimeToString } from '../../../utils/dateTimeUtils';
import { backdropClasses, Divider, Paper } from '@mui/material';
import theme from '../../../theme';
import { border, borderBottom, borderLeft, borderRight, height, textAlign, width } from '@mui/system';
import { PaperTitle } from '../text/text';

const Widget = (
  {
    show, 
    title, 
    children, 
    leftWidth, 
    intervalOptions, 
    onOptionSelected, 
    selectedInterval,
    setStartTime,
    setEndTime,
    oldPicker = true,
    startTime,
    endTime
  }) => {
  const [showLoading, setShowLoading] = useState(false)
  useLoadingTimer(setShowLoading)

  return (
      <View extend={[styles.widget,styles.border]}>
        {
          showLoading && !show && (
            <H3 children={'Loading...'} />
          )
        }
        <CSSTransition
          in={ show }
          timeout={300}
          classNames="widget"
          unmountOnExit
        >
          <View>
          <View>
            <View extend={
            {
              display: 'flex',
              flexDirection: 'row',
              width:'100%',
              justifyContent:'space-evenly',
              borderBottom: `0.5px solid ${theme.colors.lightDividerGrey}` 
            }}>
              
              <PaperTitle 
                extend={{ 
                  letterSpacing: "0.04em", 
                  alignSelf:'center', 
                  textAlign: 'center',
                  backdropColor: 'red',
                  flexGrow: oldPicker ? 3 : 5,  
                  }} 
                  bold 
                  text={title}
              />
              {
                !oldPicker ?
                  <Fragment>
                    <TimeSelector
                      timeSelectors={[timespanOptions.month, timespanOptions.week, timespanOptions.day]}
                      setStartTime={setStartTime}
                      setEndTime={setEndTime}
                      startTime={startTime}
                      endTime={endTime}
                    />
                    <P extend={{marginLeft: 20, flexGrow: oldPicker ? 3 : 5 }}>{dateTimeToString(DateTime.fromISO(startTime), 'date-only')}  - {dateTimeToString(DateTime.fromISO(endTime), 'date-only')}</P>
                  </Fragment> 
                  : intervalOptions && intervalOptions?.length && <RadioButtonSelector onChange={onOptionSelected} options={intervalOptions} value={selectedInterval} disabled={false}/>
                
              }
            </View>
          </View>
            <View extend={ styles.content }>
              {
                children.map((child) => {
                  return (
                    <View key={child.name} extend={ styles[child.name] }>
                      { child.body }
                    </View>
                  )
                })
              }
            </View>
          </View>
        </CSSTransition>
      </View>
    )
}

const TimeSelector = (
  {
    timeSelectors,
    setStartTime,
    setEndTime,
    startTime,
    endTime
  }) =>
{
 return(
  <Fragment>
    <View extend={{ borderLeft: `0.5px solid ${theme.colors.lightDividerGrey}`}}/>
    {timeSelectors?.map((timespan, index) => {
      return (
        <View extend={{flexGrow: 5, borderRight: `0.5px solid ${theme.colors.lightDividerGrey}`}}>
          <TimespanPicker
            extendButton={{height: '100%', width: '100%'}}
            key={index} 
            timespan={timespan}
            setSelectedStartTime={(newDate) => setStartTime(newDate)} 
            setSelectedEndTime={(newDate) => setEndTime(newDate)} 
            startTime={startTime}
            endTime={endTime}
            onTimeframePicked={timespan} 
            timespanOption={timespan}
          />
        </View>
      )
      })}
  </Fragment>
 )
}

const styles = {
  widget: ({ theme: { layout, colors } }) => ({
    //borderRadius: `${ 1 * layout.grid}px`,
    paddingHorizontal: `${ 2 * layout.grid}px ${ 3 * layout.grid}px`,
    paddingBottom: `${ 2 * layout.grid}px ${ 3 * layout.grid}px`,
    width: '100%',
    minHeight: '300px',
    margin: `0 0 ${2 * layout.grid}px 0`,
  }),
  content: ({ theme: { layout, colors } }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: `${layout.grid}px`,
    // width: '100%',
  }),
  optionButtons: ({ theme: { layout, colors } }) => ({
    display: 'inline-flex',
    flexDirection: 'row',
    marginLeft: 12
  }),
  left: {
    minWidth: '70px',
    paddingRight: '30px'
  },
  right: {
    width: '100%',
    height: '220px'
  },
  border: ({}) =>({
    borderBottom: `0.5px solid ${theme.colors.lightDividerGrey}`,
    borderTop: `0.5px solid ${theme.colors.lightDividerGrey}`,
    borderRight: `0.5px solid ${theme.colors.lightDividerGrey}`,
    borderLeft: `0.5px solid ${theme.colors.lightDividerGrey}`,
  })
};

export default Widget;
